import { post, postJson, postFileDownload } from '@/utils/request';

// #region ******** 收计费管理 ********
// 列表
export const getReportInvoiceCodeList = params => {
  return post(`/app/etmt/getReportInvoiceCodeList`, params);
};
// 详情
export const getReportInvoiceCodeInfo = params => {
  return post(`/app/etmt/getReportInvoiceCodeInfo`, params);
};
// 批量设置发票号
export const editReportInvoiceCodeBatch = params => {
  return post(`/app/etmt/editReportInvoiceCodeBatch`, params);
};
// 设置样品单价
export const editSampleInfoPrice = params => {
  return postJson(`/app/etmt/editSampleInfoPrice`, params);
};
// 下载收费单
export const exportReportInvoiceCodeInfo = params => {
  return postFileDownload(`/app/etmt/exportReportInvoiceCodeInfo`, params, { responseType: 'blob' });
};
// 下载发票通知单
export const exportReportInvoiceApply = params => {
  return postFileDownload(`/app/etmt/exportReportInvoiceApply`, params, { responseType: 'blob' });
};
// 下载已开票发票信息
export const exportReportInvoiceCodeList = params => {
  return postFileDownload(`/app/etmt/exportReportInvoiceCodeList`, params, { responseType: 'blob' });
};
// 下载试验项目及收费台账
export const exportReportInvoiceCodeListV1 = params => {
  return postFileDownload(`/app/etmt/exportReportInvoiceCodeListV1`, params, { responseType: 'blob' });
};
// 发票抬头新增/编辑
export const editInvoiceTitle = params => {
  return post(`/app/editInvoiceTitle`, params);
};
// 发票抬头详情
export const getInvoiceTitle = params => {
  return post(`/app/getInvoiceTitle`, params);
};
// 发票抬头列表
export const getMyInvoiceTitleAllList = params => {
  return post(`/app/getMyInvoiceTitleAllList`, params);
};
// #endregion **** 收计费管理 ********
